/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerSignupAccountDraft } from './';
import {
    FreelancerSignupAccountDraftFromJSON,
    FreelancerSignupAccountDraftFromJSONTyped,
    FreelancerSignupAccountDraftToJSON,
} from './';
import type { FreelancerSignupProfileDraft } from './';
import {
    FreelancerSignupProfileDraftFromJSON,
    FreelancerSignupProfileDraftFromJSONTyped,
    FreelancerSignupProfileDraftToJSON,
} from './';
import type { SignupCompletion } from './';
import {
    SignupCompletionFromJSON,
    SignupCompletionFromJSONTyped,
    SignupCompletionToJSON,
} from './';
import type { SignupCompletionField } from './';
import {
    SignupCompletionFieldFromJSON,
    SignupCompletionFieldFromJSONTyped,
    SignupCompletionFieldToJSON,
} from './';
import type { SignupContext } from './';
import {
    SignupContextFromJSON,
    SignupContextFromJSONTyped,
    SignupContextToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerSignupWorkflow
 */
export interface FreelancerSignupWorkflow {
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupWorkflow
     */
    id: string;
    /**
     * 
     * @type {SignupContext}
     * @memberof FreelancerSignupWorkflow
     */
    context: SignupContext;
    /**
     * 
     * @type {Array<SignupCompletionField>}
     * @memberof FreelancerSignupWorkflow
     */
    ignoreCompletionFields: Array<SignupCompletionField>;
    /**
     * 
     * @type {Array<SignupCompletion>}
     * @memberof FreelancerSignupWorkflow
     */
    freelancerSignupCompletion: Array<SignupCompletion>;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupWorkflow
     */
    freelancerSignupWorkflowState: FreelancerSignupWorkflowFreelancerSignupWorkflowStateEnum;
    /**
     * 
     * @type {FreelancerSignupAccountDraft}
     * @memberof FreelancerSignupWorkflow
     */
    freelancerSignupAccountDraft?: FreelancerSignupAccountDraft;
    /**
     * 
     * @type {FreelancerSignupProfileDraft}
     * @memberof FreelancerSignupWorkflow
     */
    freelancerSignupProfileDraft: FreelancerSignupProfileDraft;
}


/**
 * @export
 */
export const FreelancerSignupWorkflowFreelancerSignupWorkflowStateEnum = {
    Initialized: 'INITIALIZED',
    EmailValidationPending: 'EMAIL_VALIDATION_PENDING',
    EmailValidated: 'EMAIL_VALIDATED',
    Finished: 'FINISHED'
} as const;
export type FreelancerSignupWorkflowFreelancerSignupWorkflowStateEnum = typeof FreelancerSignupWorkflowFreelancerSignupWorkflowStateEnum[keyof typeof FreelancerSignupWorkflowFreelancerSignupWorkflowStateEnum];


/**
 * Check if a given object implements the FreelancerSignupWorkflow interface.
 */
export function instanceOfFreelancerSignupWorkflow(value: object): value is FreelancerSignupWorkflow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('context' in value) || value['context'] === undefined) return false;
    if (!('ignoreCompletionFields' in value) || value['ignoreCompletionFields'] === undefined) return false;
    if (!('freelancerSignupCompletion' in value) || value['freelancerSignupCompletion'] === undefined) return false;
    if (!('freelancerSignupWorkflowState' in value) || value['freelancerSignupWorkflowState'] === undefined) return false;
    if (!('freelancerSignupProfileDraft' in value) || value['freelancerSignupProfileDraft'] === undefined) return false;
    return true;
}

export function FreelancerSignupWorkflowFromJSON(json: any): FreelancerSignupWorkflow {
    return FreelancerSignupWorkflowFromJSONTyped(json, false);
}

export function FreelancerSignupWorkflowFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerSignupWorkflow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'context': SignupContextFromJSON(json['context']),
        'ignoreCompletionFields': ((json['ignoreCompletionFields'] as Array<any>).map(SignupCompletionFieldFromJSON)),
        'freelancerSignupCompletion': ((json['freelancerSignupCompletion'] as Array<any>).map(SignupCompletionFromJSON)),
        'freelancerSignupWorkflowState': json['freelancerSignupWorkflowState'],
        'freelancerSignupAccountDraft': json['freelancerSignupAccountDraft'] == null ? undefined : FreelancerSignupAccountDraftFromJSON(json['freelancerSignupAccountDraft']),
        'freelancerSignupProfileDraft': FreelancerSignupProfileDraftFromJSON(json['freelancerSignupProfileDraft']),
    };
}

export function FreelancerSignupWorkflowToJSON(value?: FreelancerSignupWorkflow | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'context': SignupContextToJSON(value['context']),
        'ignoreCompletionFields': ((value['ignoreCompletionFields'] as Array<any>).map((v) => SignupCompletionFieldToJSON(v))),
        'freelancerSignupCompletion': ((value['freelancerSignupCompletion'] as Array<any>).map((v) => SignupCompletionToJSON(v))),
        'freelancerSignupWorkflowState': value['freelancerSignupWorkflowState'],
        'freelancerSignupAccountDraft': FreelancerSignupAccountDraftToJSON(value['freelancerSignupAccountDraft']),
        'freelancerSignupProfileDraft': FreelancerSignupProfileDraftToJSON(value['freelancerSignupProfileDraft']),
    };
}

